// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import VuePrlx from 'vue-prlx'
import 'element-ui/lib/theme-chalk/index.css';

import axios from 'axios'//引入axios
import qs from 'qs'//引入qs
import API from '../src/axios/api'//引入api配置文件
import getToken from './axios/token'//引入axios带有拦截器的实例
import upOss from './axios/oss'//引入axios不带拦截器的实例

import VueCropper from 'vue-cropper'//引入图片裁剪

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VuePrlx);
Vue.use(VueCropper);

Vue.prototype.$axios = axios;//全局注册axios
Vue.prototype.$API = API;//全局注册API
Vue.prototype.$getToken = getToken;//全局注册axios带有拦截器的实例
Vue.prototype.$upOss = upOss;//全局注册axios带有拦截器的实例
Vue.prototype.$qs = qs;//全局注册qs


// 全局配置axios默认项
axios.defaults.baseURL = API.baseURL//请求地址
/* eslint-disable no-new */

// 根据路由设置标题
router.beforeEach((to, from, next) => {
  /*路由发生改变修改页面的title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
})

new Vue({
  el: '#app',
  router,
  mounted() {
    document.dispatchEvent(new Event('render-active'))
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js